export default __webpack_public_path__ + "static/media/03.078a0a11.jpg";